import React from "react";
import { ShowCampaignTabStatistic } from "@client/pages/ShowCampaign/Tabs/ShowCampaignTabStatistic";
import { CampaignReviewData } from "@common/api/__generated__";

interface Props {
  campaign: CampaignReviewData;
}

export const EditCampaignTabStatistic: React.FC<Props> = ({
  campaign,
}: Props) => {
  return <ShowCampaignTabStatistic campaign={campaign} />;
};
